import React from 'react';
import { useParams } from 'react-router-dom';

import AccountUserDetailWrap from '../../../views/account/user/detail/AccountUserDetailWrap';
import { useCurrentTab } from './hooks/useCurrentTab';

const AccountUserDetailContainer = () => {
  const { currentTab, setTabKey } = useCurrentTab();
  const { id } = useParams();

  return (
    <AccountUserDetailWrap
      /**
       * id에 'abcs'와 같은 문자열이 들어올 경우 Number()를 하게되면 NaN으로 변환
       * userId를 인식하지 못해서 api요청 자체가 시작x
       * 404페이지로 넘어가지 않는 문제가 있어서 string값일 경우 문자열 그대로 id로 넘겨줌
       */
      userId={isNaN(Number(id)) ? id : Number(id)}
      currentTabKey={String(currentTab)}
      setTabKey={setTabKey}
    />
  );
};

export default AccountUserDetailContainer;
